/**
 * @module sessionStorage
 * @since 2.0.0
 */

import { Storage } from '../__Storage';

/**
 * A wrapper around the native `sessionStorage`, failsafing usage for non-compliant browsers (e.g. incognito Safari), and basic methods.
 * @type {Storage}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
 */
export const sessionStorage = new Storage('sessionStorage');
